import { render, staticRenderFns } from "./categoryTablesign.vue?vue&type=template&id=10b58090&scoped=true"
import script from "./categoryTablesign.vue?vue&type=script&lang=js"
export * from "./categoryTablesign.vue?vue&type=script&lang=js"
import style0 from "./categoryTablesign.vue?vue&type=style&index=0&id=10b58090&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b58090",
  null
  
)

export default component.exports